var swiper4 = new Swiper(".swiper", {
  slidesPerView: 4,
  spaceBetween: 30,
  loop: false,
  watchOverflow: true,
  navigation: {
    nextEl: '.arrow.next',
    prevEl: '.arrow.prev',
  },
  breakpoints: {
    320: { slidesPerView: 1, spaceBetween: 10 },
    480: { slidesPerView: 1, spaceBetween: 10 },
    640: { slidesPerView: 2, spaceBetween: 20 },
    768: { slidesPerView: 3 },
    1280: { slidesPerView: 4 },
  },
});

  $(document).ready(function() {
    $('[data-button="reset_all"]').on('click', function() {
      var $sidebar = $('[data-sidebar]');
      $sidebar.find('input[type="checkbox"], input[type="radio"]').prop('checked', false);
      $sidebar.find('select').prop('selectedIndex', 0);
      $('.collection-top-bar__active-elements').find('a[data-remove-filter]').remove();
      resetFilterEffects();
    });

    function resetFilterEffects() {
      console.log('Filter effects reset');
    }
  });
